import { render, staticRenderFns } from "./FerryCreate.vue?vue&type=template&id=4ca3ad57"
import script from "../../controllers/ferry/ferry-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry/ferry-create.js?vue&type=script&lang=js&external"
import style0 from "./FerryCreate.vue?vue&type=style&index=0&id=4ca3ad57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports